<template>
  <div class="container-fluid terms pt-2">
    <div class="row justify-content-center mb-2">
      <div class="col-md-8 text-center">
        <div>
          P&aacute;gina <input v-model.number="page" type="number" min="1" :max="numPages">  de {{numPages}}
        </div>
      </div>
    </div>
    <div class="row justify-content-center mb-2">
      <div class="col-md-8 text-center">
        <div v-if="loadedRatio > 0 && loadedRatio < 1" class="loaded-ratio" :style="{ width: loadedRatio * 100 + '%' }">
          {{ Math.floor(loadedRatio * 100) }}%
        </div>
        <pdf ref="pdf" class="frame" :src="src" :page="page" @progress="loadedRatio = $event" @num-pages="numPages = $event" @link-clicked="page = $event"></pdf>
      </div>
    </div>
    <div class="row justify-content-center mb-2">
      <div class="col-md-8 text-center">
        <div>
          P&aacute;gina <input v-model.number="page" type="number" min="1" :max="numPages">  de {{numPages}}
        </div>
      </div>
    </div>
    <div class="row justify-content-center mb-2">
      <div class="col-md-8 text-center">
        <button type="button" class="btn btn-primary" @click="close">Cerrar</button>
      </div>
    </div>
  </div>
</template>

<script>
import pdf from 'vue-pdf'

export default {
  components: {
    pdf
  },
  props: {
    termId: String
  },
  data () {
    return {
      src: '',
      loadedRatio: 0,
      page: 1,
      numPages: 0
    }
  },
  mounted () {
    switch (Number(this.termId)) {
      case 1:
        this.src = './files/TyC_MEDISMART.pdf'
        break
      case 2:
        this.src = './files/TyC_MisAbogados.pdf'
        break
      case 3:
        this.src = './files/TyC_BCN.pdf'
        break
      case 4:
        this.src = './files/TyC_TeConecto.pdf'
        break
      default:
        this.src = ''
    }
  },
  methods: {
    close () {
      window.close()
    }
  }
}

</script>
